import { useEffect, useState } from "react";
import { resolver } from "../../../API/middlewares/resolveRequests";
import { applicantLookups } from "../../../API/services/utilities";
import {
  getUsers,
  updateUserData,
} from "../../../API/store/actions/admin/userAction";
import ModalComponent from "../../reusableComponents/modal";
import AddUserForm from "./adduser/addUserForm";
import UserRoles from "./addUserRoles";
import DeleteUser from "./deleteUser";
const UsersAlerts = ({
  userToken,
  modalVisible,
  setModalVisible,
  onSuccess,
}) => {
  const { addRole, deleteUser, ediUser, helperData, addUserData } =
    modalVisible;
  const [data, setData] = useState(null);
  const [dropdownLists, setDropdownLists] = useState(null);
  const [usersDropdownLists, setUsersDropdownLists] = useState(null);
  const [usersEditDropdownLists, setUsersEditDropdownLists] = useState(null);
  useEffect(() => {
    if (ediUser) {
      setData(null);
      setUsersEditDropdownLists(null);
      resolver(updateUserData, setData, helperData?.id, userToken);
      // resolver(applicantLookups, setDropdownLists);
      resolver(getUsers, setUsersEditDropdownLists, 1, 1000, userToken);
    }

    if (addUserData) {
      setUsersDropdownLists(null);
      // resolver(applicantLookups, setDropdownLists);
      resolver(getUsers, setUsersDropdownLists, 1, 1000, userToken);
    }
  }, [ediUser, addRole, addUserData]);

  let usersDropdownListsMapped =
    usersDropdownLists?.data &&
    usersDropdownLists.data.map((list) => ({
      name: list.firstName,
      id: list.id,
    }));

  let usersEditDropdownListsMapped =
    usersEditDropdownLists?.data &&
    helperData?.id &&
    usersEditDropdownLists.data
      .filter((list) => list.id !== helperData.id)
      .map((list) => ({
        name: list.firstName,
        id: list.id,
      }));
  return (
    <>
      {addUserData ? (
        <ModalComponent
          hasImage={
            <img
              src={"/assets/images/addicon3.svg"}
              width={"100%"}
              height={"100%"}
            />
          }
          title={"اضافة مستخدم "}
          modalVisible={addUserData}
          setModalVisible={() => {
            setModalVisible({ ...modalVisible, addUserData: !addUserData });
          }}
          body={
            usersDropdownListsMapped ? (
              <AddUserForm
                userToken={userToken}
                setModalVisible={setModalVisible}
                // dropdownLists={dropdownLists.data}
                usersDropdownLists={usersDropdownListsMapped}
                onSuccess={onSuccess}
              />
            ) : (
              <>LOADING</>
            )
          }
        ></ModalComponent>
      ) : ediUser ? (
        <ModalComponent
          title={"تعديل بيانات المستخدم"}
          modalVisible={ediUser}
          setModalVisible={() => {
            setData(null);
            setModalVisible({ ...modalVisible, ediUser: !ediUser });
          }}
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          body={
            data ? (
              <AddUserForm
                userToken={userToken}
                isEdit
                data={data?.data}
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                // dropdownLists={dropdownLists.data}

                usersDropdownLists={usersEditDropdownListsMapped}
                onSuccess={onSuccess}
              />
            ) : (
              <>LOADING</>
            )
          }
        ></ModalComponent>
      ) : deleteUser ? (
        <ModalComponent
          modalVisible={deleteUser}
          setModalVisible={() => {
            setModalVisible({
              ...modalVisible,
              deleteUser: !deleteUser,
            });
          }}
          body={
            <DeleteUser
              userToken={userToken}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
            />
          }
          size={"s"}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
      ) : addRole ? (
        <ModalComponent
          modalVisible={addRole}
          setModalVisible={() => {
            setModalVisible({
              ...modalVisible,
              addRole: !addRole,
            });
          }}
          body={
            <UserRoles
              userToken={userToken}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"ضبط الصلاحيات"}
          background={"modalBackground mx-5"}
        />
      ) : null}
    </>
  );
};

export default UsersAlerts;
